import { getCredentialDisplayName } from 'marketplace-ui-common/utils/credentials';
export const getAccreditationsRequestState = state => state.accreditations.requestState;
export const getAccreditations = state => state.accreditations.data;
export const getAccreditationsKeyMirror = state => state.accreditations.data.reduce((obj, accreditation) => {
  obj[accreditation.id] = getCredentialDisplayName(accreditation, 'en');
  return obj;
}, {});